import { Backdrop } from '@material-ui/core';
import React, { createElement, useState } from 'react';
import styled from 'styled-components';

import { CheckDoneIcon, DeleteXIcon } from '../../assets/icons/iconRepository';
import { TinyLogos } from '../../components/ManageCollaboratorsForm/index.styled';
import { Button } from '../../components/buttons';
import Modal from '../../components/globals/Modal';
import { text } from '../../components/text';
import Spinner from "../../components/Spinner"
import GlobalTheme from '../../styled/GlobalTheme';

/** @type {(props: { step: number, title: string, button: string, modalTitle: string, disabled: boolean, children: JSX.Element, handleModalSaveClick: VoidFunction, isFinished: boolean, isLoading: boolean, width?: string, subtitle?: string }) => JSX.Element} */
export const StepBanner = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = (val) => () => setIsModalOpen(val);

  const handleSaveModal = () => {
    const toggler = () => toggleModal(false)();
    props.handleModalSaveClick(toggler);
  };

  return (
    <>
      <StepBannerHero disabled={props.disabled}>
        <SphereNumber>{props.step}</SphereNumber>
        <StepBannerChildrenWrapper>
          <StepBannerTitle>{props.title}</StepBannerTitle>
          <StepBannerSubtitle>{props.subtitle || ''}</StepBannerSubtitle>
          {!props.isFinished ? (
            <StepBannerButton
              disabled={props.disabled}
              id={`mbutton-${props.step}`}
              onClick={!props.disabled ? toggleModal(true) : undefined}
            >
              {props.button}
            </StepBannerButton>
          ) : (
            <MarkAsDoneIcon />
          )}
        </StepBannerChildrenWrapper>
      </StepBannerHero>

      <ModalForStepBanner
        width={props.width}
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        title={props.modalTitle}
        step={props.step}
        disabled={props.disabled}
        isLoading={props.isLoading}
        handleModalSaveClick={handleSaveModal}
      >
        {props.children}
      </ModalForStepBanner>
    </>
  );
};

const ModalForStepBanner = (props) => {
  return (
    <StepBannerModalHero
      width={props.width}
      open={props.isModalOpen}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
      onClose={props.toggleModal(false)}
    >
      <CloseButton onClick={props.toggleModal(false)} />
      <StepBannerModalTitle>
        {props.step}.&nbsp;{props.title}
      </StepBannerModalTitle>
      {props.children}
      <StepBannerModalSaveButton onClick={props.handleModalSaveClick} disabled={props.isLoading || props.disabled}>
        { props.isLoading 
          ? <Spinner />
          : text('onboarding.biz.modal.save')
        }
      </StepBannerModalSaveButton>
    </StepBannerModalHero>
  );
};

/** @type {(props: { accounts: Array<'facebook' | 'instagram' | 'linkedin' | 'twitter'> }) => JSX.Element} */
export const ConnectedTinyLogos = (props) => {
  return props.accounts.map((account, i) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <CheckForTinyLogos isCheked={props.checked[i]} />
        <CheckLogos account={account} />
      </div>
    );
  });
};

const CheckForTinyLogos = ({ isCheked }) => isCheked
  ? (<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M6.5 12.5L10 16L17.5 8.5' stroke='#009DB2' stroke-width='2' stroke-linecap='round' />
    </svg>)
  : (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="5" y1="5" x2="19" y2="19" stroke="red" stroke-width="2" stroke-linecap="round"/>
      <line x1="19" y1="5" x2="5" y2="19" stroke="red" stroke-width="2" stroke-linecap="round"/>
    </svg>);

/** @type {(props: { account: Lowercase<string> }) => typeof TinyLogos[string]} */
const CheckLogos = (props) => {
  const block = props.account.charAt(0).toUpperCase() + props.account.slice(1);

  return createElement(TinyLogos[block]);
};

const StepBannerModalHero = styled(Modal)`
  && {
    .MuiPaper-root {
      min-width: 68% !important;
    }
  }
`;

const MarkAsDoneIcon = styled.span`
  margin-left: auto;
  margin-right: 20px;
  margin-top: auto;
  margin-bottom: auto;
  display: block;
  width: 24px;
  height: 18.1px;
  flex-shrink: 0;
  background-image: url(${CheckDoneIcon});
  background-position: center center;
  background-repeat: no-repeat;
  grid-column: 2 / 3;
  grid-row: 1 / 3;

  ${GlobalTheme.breakpoints.down('md')} {
    grid-column: 1 / 3;
    grid-row: 3;
    margin-top: 10px;
    margin-right: auto;
    margin-left: auto;
  }
`;

const StepBannerModalTitle = styled.p`
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 42px;
  color: ${(props) => props.theme.colors.black3E};
`;

const CloseButton = styled.button`
  border: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  position: absolute;
  z-index: 9;
  top: 12px;
  right: 12px;
  background-image: url(${DeleteXIcon});
  background-repeat: no-repeat;
  background-position: center center;
  background-color: transparent;
`;

const StepBannerModalSaveButton = styled(Button)`
  margin-top: 50px !important;
  height: auto;
  width: 85px;
  padding: 8px 24px;
  flex-direction: column;
  margin-left: auto !important;
  margin-right: 0px !important;
  align-items: center;
  border-radius: 4px;
  background: ${(props) => props.theme.colors.primaryMoreLighter};
  color: ${(props) => props.theme.colors.white};
  text-align: center;
  font-size: 16px;
  font-weight: 600;
`;

export const StepBannersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
  width: 100%;
  margin-bottom: 35px;
  padding-left: 23%;
  padding-right: 23%;
  padding-top: 16px;

  ${GlobalTheme.breakpoints.down('lg')} {
    padding-left: 10%;
    padding-right: 10%;
  }

  ${GlobalTheme.breakpoints.down('sm')} {
    padding-left: 5%;
    padding-right: 5%;
  }
`;

export const Hero = styled.div`
  display: grid;
  place-items: center;
  padding-top: 40px;
  padding-bottom: 200px;
`;

export const Title = styled.p`
  color: ${(props) => props.theme.colors.black3E};
  font-size: 32px;
  font-weight: 600;
  white-space: break-spaces;

  ${GlobalTheme.breakpoints.down('md')} {
    font-size: 18px;
    margin-left: -18px;
  }
`;

export const TitleDivisor = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 18%;
  padding-right: 18%;

  ${GlobalTheme.breakpoints.down('md')} {
    padding-left: 5%;
    padding-right: 5%;
  }
`;

export const StepBannerHero = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 28px 22px;
  width: 100%;
  box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.15);
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  border: 1px solid ${(props) => props.theme.colors.grayE9};
  background: ${(props) => props.theme.colors.white};
`;

export const SphereNumber = styled.span`
  min-width: 45px;
  min-height: 45px;
  display: grid;
  place-items: center;
  font-size: 26px;
  font-weight: 400;
  border-radius: 100%;
  background: ${(props) => props.theme.colors.secondary};
  color: ${(props) => props.theme.colors.black};
`;

export const StepBannerTitle = styled.p`
  font-size: 18px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.black};

  ${GlobalTheme.breakpoints.down('md')} {
    grid-column: 1 / 3;
  }
`;

export const StepBannerSubtitle = styled.p`
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
  gap: 7px;

  grid-column: 1 / 2;
  grid-row: 2 / 3;
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.gray90};

  ${GlobalTheme.breakpoints.down('md')} {
    grid-column: 1 / 3;
  }
`;

export const StepBannerChildrenWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 80% 20%;
  grid-template-rows: max-content 25px;

  ${GlobalTheme.breakpoints.down('md')} {
    grid-template-rows: repeat(3, max-content);
  }
`;

export const StepBannerButton = styled(Button)`
  grid-column: 2 / 3;
  grid-row: 1 / 3;

  && {
    ${GlobalTheme.breakpoints.down('md')} {
      grid-column: 1 / 3;
      grid-row: 3;

      margin-top: 10px;
      margin-right: auto;
      margin-left: auto;
      width: 220px;
    }

    ${GlobalTheme.breakpoints.down('sm')} {
      margin-left: 0px;
      width: 100%;
    }
  }
`;

export const ContinueButton = styled(Button)``;

const DogVectorWrapper = styled.span`
  ${GlobalTheme.breakpoints.down('md')} {
    transform: scale(0.6);
  }
`;

export const StandDogVector = () => (
  <DogVectorWrapper>
    <svg
      width='100'
      height='99'
      viewBox='0 0 100 99'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_11255_3561)'>
        <path
          d='M77.7659 6.59132C36.6208 -24.434 -18.772 63.2491 6.26127 80.0267C31.2946 96.8044 148.072 59.6539 77.7659 6.59132Z'
          fill='#00B4CC'
        />
        <path
          d='M83.4879 30.9578H83.3548L74.5665 30.8912L62.0498 30.8246L65.9779 20.3053L65.2456 20.1721C64.1803 19.9058 63.0485 19.7727 61.9167 19.8393C61.3175 19.8393 60.7183 19.9724 60.1191 20.1056L61.1177 17.4424L60.3854 17.1761C59.1204 16.7101 57.7223 16.5104 56.3907 16.5769C53.7276 16.7101 51.2642 17.7753 49.4666 19.5729L49.3335 19.7061C46.2709 22.7021 44.0072 28.0949 43.7409 32.8885C43.0751 45.2054 39.5465 53.4611 33.0884 58.1881C29.6264 60.4518 27.4293 59.4531 25.0991 57.3226L22.7689 54.9924L29.1603 53.3945L10.7183 37.6821L16.1111 50.4651L9.91934 51.9298L18.5745 66.3772L3.32812 90.2787V98.5343H14.0472L13.9806 97.7354C13.914 96.8699 13.448 95.7381 13.0485 94.7394C12.9819 94.5396 12.8488 94.3399 12.7822 94.1402L18.2416 87.3492C18.3082 87.3492 18.3747 87.3492 18.4413 87.3492C20.7715 87.3492 23.0352 86.9498 25.1657 86.1508L28.4946 98.5343H38.4147L38.2815 97.6688C38.0152 95.6049 36.95 93.6741 35.0858 92.0763C35.8847 89.0803 36.8168 84.6195 37.1497 82.8885C37.9486 82.9551 38.7476 83.0217 39.5465 83.0217C41.2775 83.0217 43.0086 82.8219 44.6064 82.4891L42.8754 98.5343H53.8608L53.7942 97.7354C53.5944 95.3386 52.7955 93.8739 51.7303 92.276L58.9872 73.9005C60.5185 74.5663 61.3841 75.5649 61.7835 76.031C61.9167 76.1642 61.9833 76.2973 62.0498 76.3639C62.1164 76.4305 62.1164 76.4305 62.183 76.4305L59.9193 82.4891C59.8528 82.6888 59.8528 82.8885 59.9859 83.0883C60.0525 83.288 60.2522 83.4211 60.452 83.4877C60.8514 83.6209 61.3175 83.6209 61.8501 83.6209C62.5159 83.6209 63.2482 83.5543 63.7143 83.4877C66.444 83.0217 68.8408 81.557 70.4387 79.2933C72.1031 76.9631 72.7023 74.1668 72.2363 71.4371C71.5705 67.5756 68.3082 64.2467 64.1803 63.1815C64.5798 61.3839 64.7795 59.5863 64.7795 57.7221C64.7795 57.6555 64.7795 56.3239 64.7795 55.5916C74.4999 55.059 82.6224 47.2693 83.4879 37.4158C83.4879 36.9498 83.5545 36.1508 83.5545 35.2187C84.42 34.2867 84.9526 33.0217 84.9526 31.7567V31.0243L83.4879 30.9578Z'
          fill='white'
        />
        <path
          d='M38.8833 54.3946C38.617 53.9286 38.2175 53.396 37.9512 53.1962C36.553 55.1936 34.9552 56.858 33.091 58.2562C29.6289 60.5198 27.4319 59.5211 25.1016 57.3906L22.7714 55.0604L29.1629 53.4626L10.7208 37.6836L16.1136 50.4666L9.92188 51.9313C9.92188 51.9313 18.2441 65.7795 18.577 66.3787C18.9765 66.9779 19.5757 67.6436 19.5757 67.6436C21.7727 69.7741 24.7688 71.0391 27.8979 71.0391C34.4891 71.0391 39.8819 65.6463 39.8819 59.0551C39.8819 57.4572 39.549 55.9259 38.8833 54.3946Z'
          fill='black'
        />
        <path
          d='M70.2365 30.9578H62.114H60.5161H56.2551L61.1819 17.4424L60.4495 17.1761C59.1845 16.7101 57.7864 16.5104 56.3883 16.5769C53.7251 16.7101 51.2618 17.7753 49.4642 19.5729L49.331 19.7061C46.2684 22.7021 43.9382 28.0949 43.6719 32.9551C43.6719 34.553 44.3377 36.3506 44.8037 37.4158C45.4695 39.0137 46.4016 40.545 47.6 41.81C50.0634 44.4731 53.3923 45.9378 56.9875 45.9378H57.054C64.1779 45.9378 70.0367 39.9458 70.303 32.4891L70.2365 30.9578Z'
          fill='black'
        />
        <path
          d='M60.8517 37.2172C60.9183 38.1493 60.4522 38.9482 59.853 38.9482C59.2538 38.9482 58.7212 38.2158 58.7212 37.2838C58.6546 36.3517 59.1207 35.5527 59.7199 35.5527C60.2525 35.5527 60.7851 36.2851 60.8517 37.2172Z'
          fill='white'
        />
        <path
          d='M83.4879 30.9578H83.3548L74.5665 30.8912L62.0498 30.8246L65.9779 20.3053L65.2456 20.1721C64.1803 19.9058 63.0485 19.7727 61.9167 19.8393C61.3175 19.8393 60.7183 19.9724 60.1191 20.1056L61.1177 17.4424L60.3854 17.1761C59.1204 16.7101 57.7223 16.5104 56.3907 16.5769C53.7276 16.7101 51.2642 17.7753 49.4666 19.5729L49.3335 19.7061C46.2709 22.7021 44.0072 28.0949 43.7409 32.8885C43.0751 45.2054 39.5465 53.4611 33.0884 58.1881C29.6264 60.4518 27.4293 59.4531 25.0991 57.3226L22.7689 54.9924L29.1603 53.3945L10.7183 37.6821L16.1111 50.4651L9.91934 51.9298L18.5745 66.3772L3.32812 90.2787V98.5343H14.0472L13.9806 97.7354C13.914 96.8699 13.448 95.7381 13.0485 94.7394C12.9819 94.5396 12.8488 94.3399 12.7822 94.1402L18.2416 87.3492C18.3082 87.3492 18.3747 87.3492 18.4413 87.3492C20.7715 87.3492 23.0352 86.9498 25.1657 86.1508L28.4946 98.5343H38.4147L38.2815 97.6688C38.0152 95.6049 36.95 93.6741 35.0858 92.0763C35.8847 89.0803 36.8168 84.6195 37.1497 82.8885C37.9486 82.9551 38.7476 83.0217 39.5465 83.0217C41.2775 83.0217 43.0086 82.8219 44.6064 82.4891L42.8754 98.5343H53.8608L53.7942 97.7354C53.5944 95.3386 52.7955 93.8739 51.7303 92.276L58.9207 73.9005C60.452 74.5663 61.3175 75.5649 61.7169 76.031C61.8501 76.1642 61.9167 76.2973 61.9833 76.3639C62.0498 76.4305 62.0498 76.4305 62.1164 76.4305L59.9193 82.5556C59.8528 82.7554 59.8528 82.9551 59.9859 83.1548C60.0525 83.3546 60.2522 83.4877 60.452 83.5543C60.8514 83.6875 61.3175 83.6875 61.8501 83.6875C62.5159 83.6875 63.2482 83.6209 63.7143 83.5543C66.444 83.0883 68.8408 81.6235 70.4387 79.3599C72.1031 77.0297 72.7023 74.2334 72.2363 71.5037C71.5705 67.6422 68.3082 64.3799 64.1803 63.248C64.5798 61.4504 64.7795 59.6528 64.7795 57.7887C64.7795 57.7221 64.7795 56.3905 64.7795 55.6582C74.4999 55.1255 82.6224 47.3359 83.4879 37.4824C83.4879 37.0163 83.5545 36.2174 83.5545 35.2853C84.42 34.3532 84.9526 33.0883 84.9526 31.8233V31.0909L83.4879 30.9578ZM62.0498 21.304C62.7156 21.2374 63.3814 21.304 64.0472 21.4371L60.5185 30.8912H56.2576L59.5199 21.8366C60.3188 21.5703 61.1843 21.3705 62.0498 21.304ZM33.4879 92.1428L33.3548 92.6089L33.7542 92.9418C35.2855 94.2068 36.2176 95.5383 36.6171 97.0696H29.6264L27.2962 88.2148C29.3601 86.8166 31.5572 84.2867 32.3561 83.1548C33.0219 83.4211 34.2203 83.8872 35.2855 84.1535C34.8195 86.4172 34.0871 89.8792 33.4879 92.1428ZM50.0658 92.4757L50.2655 92.8086C51.1976 94.2068 51.93 95.3386 52.1963 97.0696H44.5398L46.0046 83.5543C49.4 82.8219 53.1284 80.6915 55.392 78.8273L50.0658 92.4757ZM81.9566 37.2827C81.0911 46.7367 73.1018 54.1269 63.7143 54.1269C63.6477 54.1269 63.6477 54.1269 63.5811 54.1269C63.5811 54.1269 61.7835 54.0603 60.5851 53.8606C58.5212 53.5277 57.0565 51.6635 57.2562 49.6661C57.3228 49.2667 56.9899 48.8672 56.5904 48.8006C56.191 48.7341 55.7915 49.067 55.7249 49.4664C55.392 52.2627 57.3894 54.8592 60.2522 55.3253C61.2509 55.525 62.5825 55.5916 63.1817 55.5916C63.1817 56.3239 63.1817 57.6555 63.1817 57.7221C63.1817 59.7194 62.9153 61.6502 62.4493 63.5809C62.3827 63.7807 62.4493 63.9804 62.5159 64.1801C62.649 64.3799 62.7822 64.4464 62.9819 64.513C66.8434 65.2454 69.9726 68.1748 70.5718 71.7034C70.9713 74.1002 70.4386 76.497 69.0405 78.4278C67.6424 80.3586 65.645 81.6235 63.3148 82.023C62.7822 82.0896 62.1164 82.1562 61.5838 82.1562L64.2469 75.0323C64.3801 74.6994 64.2469 74.3666 63.9806 74.1668C61.3175 72.3692 57.8554 71.3705 54.7928 71.6369H54.7263C54.6597 71.6369 54.5931 71.6369 54.5265 71.7034C54.5265 71.7034 54.46 71.7034 54.46 71.77C54.3934 71.8366 54.3268 71.8366 54.3268 71.9032C54.3268 71.9032 54.2602 71.9697 54.2602 72.0363C54.2602 72.1029 54.1936 72.1029 54.1936 72.1695C54.1936 72.2361 54.1936 72.3026 54.1271 72.3026C54.1271 72.3692 54.1271 72.3692 54.1271 72.4358C54.1271 72.4358 54.1271 72.4358 54.1271 72.5024C54.1271 72.5024 54.1271 72.5024 54.1271 72.5689C54.1271 72.6355 54.1271 72.6355 54.1271 72.7021C54.1271 72.7687 54.1271 72.7687 54.1936 72.8353C54.1936 72.9018 54.2602 72.9018 54.2602 72.9684C54.2602 73.035 54.3268 73.035 54.3268 73.1016L54.3934 73.1681C54.4599 73.2347 54.46 73.2347 54.5265 73.2347C54.5931 73.2347 54.5931 73.2347 54.6597 73.2347C54.7263 73.2347 54.7263 73.2347 54.7928 73.2347C55.7249 73.2347 56.5239 73.3679 57.2562 73.501C52.7289 78.6275 46.3374 81.557 39.4133 81.557C36.8168 81.557 34.3534 81.1575 31.89 80.3586L31.424 80.2254L31.0911 80.5583C27.4959 84.1535 22.7023 86.0177 17.7755 85.8845H17.3761L10.918 93.9405L11.0512 94.3399C11.1843 94.6728 11.3175 95.0057 11.5172 95.4052C11.7169 95.9378 11.9833 96.537 12.183 97.1362H4.72626V90.8779L19.44 67.8419C19.7729 67.3759 20.0392 66.9098 20.2389 66.5104L20.1058 66.3772L12.1164 53.1282L18.0418 51.7301L14.6464 43.0084L25.898 52.6622L19.906 54.1934L24.0339 58.4544C25.432 59.7194 27.0964 60.9844 29.3601 60.9844C30.6916 60.9844 32.1564 60.5849 33.8874 59.4531C35.3521 58.3879 36.6171 57.1895 37.8155 55.7913C38.2149 55.2587 38.6144 54.7926 38.8807 54.3932C42.0099 50.1322 43.9406 44.4731 44.8062 37.2827C45.0059 35.3519 45.139 33.8872 45.2722 31.8233C45.8048 27.5623 47.8687 23.1016 50.4653 20.5716L50.7982 20.2387C52.3295 18.8406 54.3268 18.0417 56.3907 17.9751C57.3228 17.9085 58.1883 18.0417 59.1204 18.2414L53.9939 32.2893L74.5665 32.3559C74.6996 33.4211 75.2323 34.4198 76.0312 35.2187C77.0299 36.2174 78.2948 36.75 79.693 36.75C80.4919 36.75 81.2243 36.5503 81.89 36.2174C81.9566 36.75 81.9566 37.0829 81.9566 37.2827Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_11255_3561'>
          <rect width='100' height='98.5353' fill='white' />
        </clipPath>
      </defs>
    </svg>
  </DogVectorWrapper>
);
